import React from 'react';
import Layout from '../components/Layout';
import FAQ from '../components/FAQ';
import useSEO from '../hooks/useSEO';
import { useApp } from '../context/AppContext';

const DESC = {
  de: 'Antworten auf häufige Fragen zu CAB.TAXI: Festpreise, Flugverfolgung, Meet & Greet, Kindersitze, Stornierung und Zahlung für Flughafentransfers Zürich, Basel und Genf.',
  en: 'Answers to frequently asked questions about CAB.TAXI: fixed prices, flight tracking, meet & greet, child seats, cancellation and payment for airport transfers Zurich, Basel and Geneva.',
  fr: 'Réponses aux questions fréquentes sur CAB.TAXI : prix fixes, suivi des vols, accueil, sièges enfants, annulation et paiement pour les transferts aéroport Zurich, Bâle et Genève.',
  it: 'Risposte alle domande frequenti su CAB.TAXI: prezzi fissi, monitoraggio voli, meet & greet, seggiolini, cancellazione e pagamento per i transfer aeroportuali Zurigo, Basilea e Ginevra.',
};

const FaqPage = () => {
  const { lang } = useApp();
  useSEO(`${{ de: 'Häufige Fragen', en: 'FAQ', fr: 'FAQ', it: 'FAQ' }[lang]} | CAB.TAXI`, DESC[lang] || DESC.en);
  return (
    <Layout>
      <FAQ heading="h1" />
    </Layout>
  );
};

export default FaqPage;
